import { useRef } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import permissionGroups from 'modules/permissions/store/collections/permissionGroups'
import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

interface Props {
  onClose: (...args: []) => void
  permissionGroup: PermissionGroup
}
class DuplicateForm extends Form {
  constructor(values: {}) {
    super(values, {
      name: 'string',
    })
  }
}

const DuplicateGroup = ({ onClose, permissionGroup }: Props) => {
  const form = useRef(new DuplicateForm({ name: '' })).current

  const name = form.get('name')

  const onSubmit = async (closePortal: ClosePortalFn) => {
    const { value, success } = await asyncAction(() => {
      return permissionGroup.rpc('duplicate', {
        name: name.value,
      })
    })

    if (success) {
      permissionGroups.add(value)
      closePortal()
    }
  }

  return (
    <Modal
      onClose={onClose}
      onSubmit={onSubmit}
      illustration="user-interaction-review_chart"
      title={i18n.t('settings.permissions.new.title')}
      description={i18n.t('settings.permissions.new.description')}
      footer={
        <Button disabled={!name.value} submit>
          {i18n.t('common.submit')}
        </Button>
      }
    >
      <Text label={i18n.t('settings.permissions.new.name')} field={name} />
    </Modal>
  )
}

export default observer(DuplicateGroup)
